import type { Route } from '@angular/router';
import { NotFoundComponent } from '@comparit/core';
import { ShellComponent } from './shell.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'formular',
      },
      {
        path: 'formular',
        loadChildren: () => import('./formular/formular.routes').then(r => r.formularRoutes),
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
